import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class RosterWongwianyai extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterTuesday2'>
      <div><Link to='/'>Home</Link></div>
      <h3>WONGWIANYAI DOJO's MEMBERS</h3>
      <br />
      <br />

      <div><Link to='/conduct-thongchait'>1. AAT  0961  MR.THONGCHAI TIWASIRIKUL(Dojocho)(A)</Link></div>
      <br />
      <div><Link to='/conduct-kridsadad'>2. AAT  7552  MR.KRIDSADA DEEROADJANADEJ(A)</Link></div>
      <br />
      <div><Link to='/conduct-santis'>3. AAT  7518  MR.SANTI SIRISAK(A)</Link></div>
      <br />
      <div><Link to='/conduct-ronbanchoba'>4. AAT  7645  MR.RONBANCHOB APIRATIKUL(A)</Link></div>
      <br />
      <div><Link to='/conduct-chaiyutv'>5. AAT  8017  MAJ.GEN CHAIYUT VAJIRAVARABHAKTI(A)</Link></div>
      <br />
      <div><Link to='/conduct-surachett'>6. AAT  7541  MR.SURACHET THAREEPHUT(A)</Link></div>
      <br />
      <div><Link to='/conduct-karnts'>7. AAT  8007  MR.KARNT SRISUWAN(A)</Link></div>
      <br />
      <div><Link to='/conduct-pakawadn'>8. AAT  8008  MR.PAKAWAD NANTAJURAPLO(A)</Link></div>
      <br />
      <div><Link to='/conduct-chakchaia'>9. AAT  8022  1st LT.CHAKCHAI ANUPONGPAT(A)</Link></div>
      <br />
      <div><Link to='/conduct-patawank'>10. AAT  8050  MS.PATAWAN KANPLIEN(A)</Link></div>
      <br />
      <div><Link to='/conduct-kosinm'>11. AAT  8051  MR.KOSIN MUNGCHAROEN(A)</Link></div>
      <br />
      <div><Link to='/conduct-archirawishp'>12. AAT  8009  MR.ARCHIRAWISH PAKCHOTIPONG(A)</Link></div>
      <br />
      <div><Link to='/conduct-phattarakritl'>13. AAT  8059  MR.PHATTARAKRIT LAPANALARPLOY(A)</Link></div>
      <br />
      <div><Link to='/conduct-phuphumj'>14. AAT  8062  MR.PHUPHUM JIRACHANKIAT(A)</Link></div>
      <br />
      <div><Link to='/conduct-patwareek'>15. AAT  8076  MS.PATWAREE KITIWATCHARACHAROEN(A)</Link></div>
      <br />
      <div><Link to='/conduct-pasuthan'>16. AAT  8101  MR.PASUTHA NAKGUETHONG(A)</Link></div>
      <br />
        <br />
        <div>
          Thailand's Aikido Association Registration and Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default RosterWongwianyai;
